<template>
  <v-list two-line v-if="obligations && obligations.length > 0">
    <template v-for="(obligation, index) in obligations">
      <v-list-item :key="obligation._id">
        <v-list-item-action>
          <v-icon color="error">error</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ obligation.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider
        v-if="index != obligations.length - 1"
        :key="'_' + obligation._id"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "requestAccessObligationsDetails",
  methods: {
    isInvalidObligation: contractorCompanyService.isInvalidObligation,
    getFirstInvalidMessage: contractorCompanyService.getFirstInvalidMessage
  },
  props: {
    obligations: { type: Array }
  }
};
</script>

<style lang="scss"></style>
